/* =============================================================
 * import
 * ========================================================== */
import $ from 'jquery';
import TextWrap from "./textWrap";
import {gsap} from "gsap/gsap-core";
import {CustomEase} from "gsap/CustomEase";
import {ScrollToPlugin} from "gsap/ScrollToPlugin";
import Bowser from "bowser";
import {slideToggle} from "./slide";
import {eventObserver} from "./eventObserver";
import ScrollHint from "scroll-hint";

gsap.registerPlugin(CustomEase, ScrollToPlugin);
CustomEase.create("slide", ".32, .95, .6, 1");
CustomEase.create("fadeCurtain", ".25, .46, .45, .94");
CustomEase.create("fade", "0.5, 1, 0.89, 1");


/* =============================================================
 * mediaQuery
 * レスポンシブ判定
 * ========================================================== */
const windowWidth = window.innerWidth;

export function mediaQuery(width = windowWidth) {
  if (width <= 768) {
    return 'sp';
  } else {
    return 'pc';
  }
}


/* =============================================================
 * isMobile
 * タッチデバイス（SP、タブレット含む）の判別
 * ========================================================== */
export const isMobile = () => {
  const browser = Bowser.getParser(window.navigator.userAgent);
  const isTouchDevice = 'ontouchstart' in window;
  if (browser.getPlatformType(true) === 'tablet' || browser.getPlatformType(true) === 'mobile' || isTouchDevice === true) {
    return true;
  } else {
    return false;
  }
};


/* =============================================================
 * isSafari
 * Safariブラウザの判別（一部バグ回避用）
 * ========================================================== */
export const isSafari = () => {
  const browser = Bowser.getParser(window.navigator.userAgent);
  if (browser.getBrowserName() === "Safari") {
    return true;
  } else {
    return false;
  }
};


// =============================================================
// smoothScroll
// スムーズなスクロールの処理
// =============================================================
export function smoothScroll(hash, event) {

  if (event !== undefined) {
    event.preventDefault(); // barabaでの非同期遷移後に、#付きリンクがクリックされると、スクロールイベントによって通常のスクロールが発生することを防ぐ
  }

  const hum = document.querySelector('#hum');

  // 調整値の計算
  const header = document.querySelector('#header');
  const offset = header.offsetTop + header.clientHeight * 2;

  let target;
  if (hash !== undefined && hash !== null && hash !== '') {
    target = document.querySelector(hash);

    // smoother.scrollTo(target, true, "top " + offset + "px");
    // ↑ スマホの慣性スクロールを切った状態だとスムーズスクロールにならないため ↓ を使う
    gsap.to(window, {duration: 1, scrollTo: {y: target, offsetY: offset}});

  } else {
    window.scroll(0, 0);
    header.classList.remove('scrolled');
    hum.classList.remove('scrolled');
  }
}


// =============================================================
// scrollResetOnLoad
// 読み込み時のスクロール位置リセット
// =============================================================
export function scrollResetOnLoad(hash = window.location.hash) {

  if (hash !== '' && mediaQuery() === 'pc') {
    // PCの場合、通常のスクロールが動き、位置がずれてしまうので、強制的に戻す。
    // SPの場合、こちらを入れると、逆にずれてしまうので、不要。
    window.scroll(0, 0);
  }

  // locoScroll.update(); // 慣性スクロールのリセット

}


// =============================================================
// 指定テキストのspan囲み
// =============================================================
export function txtUp(elm = [...document.querySelectorAll(".js-txt-up")]) {
  elm.forEach((e) => {
    new TextWrap(e);
  });
}


// =============================================================
// スクロールバーなどを除いた画面の高さを正確に取得（主にスマホデバイス用
// =============================================================
export function setHeight() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}


// =============================================================
// 開閉ボタン
// =============================================================
export function slideDownBtn() {

  const listeners = [];
  let obj;
  const btn = [...document.querySelectorAll('.js-slideBtn')];
  const area = "js-slideCnt";
  const speed = 500;
  const slide = (e) => {
    const thisElm = e.currentTarget;
    const nextElm = e.currentTarget.nextElementSibling;

    thisElm.classList.toggle('is-open');
    if (nextElm.classList.contains(area)) {
      nextElm.classList.toggle('is-open');
      slideToggle(nextElm, speed);
    }
  };

  if (btn.length > 0) {
    btn.forEach(elem => {
      obj = {
        elem: elem,
        handleEvent: slide,
      };
      elem.addEventListener('click', obj, false);
      listeners.push([elem, 'click', obj, false]);
    });
  }

  eventObserver.observeEvents(listeners);
}


export function slideDownBtnHover() {

  const listeners = [];
  const btn = $(".js-slideBtnHover");
  const area = ".js-slideCntHover";
  const obj = {
    btn: btn,
    area: area,
  };
  const slideDown = (e) => {
    $(e.currentTarget).addClass('open');
    $(e.currentTarget).find(area).addClass('open').stop().slideDown();
  };
  const slideUp = (e) => {
    $(e.currentTarget).removeClass('open');
    $(e.currentTarget).find(area).removeClass('open').stop().slideUp();
  };

  if (btn.length) {
    if (mediaQuery() !== 'sp') {
      btn.on('mouseenter', obj, slideDown);
      btn.on('mouseleave', obj, slideUp);
      listeners.push([btn, 'mouseenter', slideDown, '$']);
      listeners.push([btn, 'mouseleave', slideUp, '$']);
    } else {
      btn.off('mouseenter', slideDown); // リサイズイベントで再実行される可能性があるため、PCサイズでは明示的に解除
      btn.off('mouseleave', slideUp); // リサイズイベントで再実行される可能性があるため、PCサイズでは明示的に解除
    }
  }

  eventObserver.observeEvents(listeners);
}

export function acodion() {

  const listeners = [];
  let obj;
  const btn = [...document.querySelectorAll('.acodion dt, .accordion dt')];
  const speed = 500;
  const slide = (e) => {
    e.stopPropagation(); // イベントの伝播を止める（多重呼び出しを防止）
    const thisElm = e.currentTarget;
    const nextElm = thisElm.nextElementSibling;

    thisElm.classList.toggle('is-open');
    nextElm.classList.toggle('is-open');
    slideToggle(nextElm, speed);
  };

  if (btn.length > 0) {
    btn.forEach(elem => {
      obj = {
        elem: elem,
        handleEvent: slide,
      };
      elem.addEventListener('click', obj, false);
      listeners.push([elem, 'click', obj, false]);
    });
  }

  eventObserver.observeEvents(listeners);
}


export function tabExchanger() {

  const listeners = [];
  let obj;
  const btn = [...document.querySelectorAll('.tab-js li[data]')];
  const target = [...document.querySelectorAll('.tab-wrap .con-con')];
  const slide = (e) => {
    const thisElm = e.currentTarget;
    const dataValue = thisElm.getAttribute('data');
    const targetElm = document.querySelector('.' + dataValue);

    if (e.currentTarget.classList.contains('active')) {
      return false;
    }

    btn.forEach(item => {
      if (item !== this && item.classList.contains('active')) {
        item.classList.remove('active');
      } else {
        item.classList.add('active');
      }
    });
    target.forEach(item => {
      if (item !== targetElm && item.classList.contains('active')) {
        item.classList.remove('active');
      } else {
        item.classList.add('active');
      }
    });

    // thisElm.classList.add('active');
    // targetElm.classList.add('active');
  };

  if (btn.length > 0) {
    btn.forEach(elem => {
      obj = {
        elem: elem,
        handleEvent: slide,
      };
      elem.addEventListener('click', obj, false);
      listeners.push([elem, 'click', obj, false]);
    });
  }

  eventObserver.observeEvents(listeners);
}


// =============================================================
// webpのサポートをチェックする関数
// =============================================================
export function supportsWebp() {
  const canvas = document.createElement("canvas");
  let webp;
  if (canvas.getContext && canvas.getContext("2d")) {
    // canvasがwebpをサポートしているかチェック
    webp = canvas.toDataURL("image/webp").indexOf("data:image/webp") == 0;
  } else {
    webp = false;
  }
  if (!webp) {
    document.body.classList.add("no-webp"); // webpをサポートしていない場合は、`no-webp`クラスをbodyタグに追加
  }
}


// =============================================================
// tableの拡張（大きいテーブルの横スクロール化）
// =============================================================
export function tableScrollHint() {

  // wrap table settings
  const contentsArea = document.querySelectorAll(".contents table");
  if (contentsArea !== null) {
    const tableAry = Array.prototype.slice.call(contentsArea);
    tableAry.forEach(function(e) {
      // テーブルが親要素より大きいかチェック
      const parentElementWidth = e.parentElement.offsetWidth;
      const tableWidth = e.offsetWidth;

      if (tableWidth > parentElementWidth) {
        if (!e.closest(".table_wrap")) {
          e.outerHTML = '<div class="table_wrap">' + e.outerHTML + '</div>';
        }
      }
    });
  }

  // scrollableJS settings
  const scrollableTrigger = document.querySelectorAll(".table_wrap");
  if (scrollableTrigger !== null) {
    const scrollableAry = Array.prototype.slice.call(scrollableTrigger);
    scrollableAry.forEach(function(scrollable) {
      const scrollHintIcon = scrollable.querySelector('.scroll-hint-icon-wrap');
      if (scrollHintIcon) {
        scrollHintIcon.remove();
      }
    });
    new ScrollHint(scrollableAry, {
      scrollHintIconAppendClass: 'scroll-hint-icon-white',
      // applyToParents: true,
      i18n: {
        scrollable: 'スクロールできます',
      },
    });
  }
}


// =============================================================
// ピックアップバナーの表示・非表示化
// =============================================================

export function pickupBnrControl(action, data = '') {

  const listeners = [];

  const target = document.querySelectorAll('.bnr_pickup');
  const wrap = document.querySelector('.bnr_pickup_wrap');

  const hyde = (e) => {
    e.classList.remove('is-active');
    gsap.to(e, {
      y: 100,
      display: "none",
      autoAlpha: 0,
      ease: "slide",
    });
  };

  if (target && wrap) {
    target.forEach((e) => {
      hyde(e);
    });

    if (action === 'show') {

      const namespace = data.namespace;
      let delay = 2.5;
      let duration = 1;
      let ease = "fade";

      if (namespace === 'home') {
        wrap.classList.add('bnr_pickup_wrap_home');
        wrap.classList.remove('bnr_pickup_wrap_home_junior');
        wrap.classList.remove('bnr_pickup_wrap_home_senior');
        delay = 1.5;
        duration = 1;
        ease = "slide";
      }

      if (namespace === 'home_junior') {
        wrap.classList.remove('bnr_pickup_wrap_home');
        wrap.classList.add('bnr_pickup_wrap_home_junior');
        wrap.classList.remove('bnr_pickup_wrap_home_senior');
      }

      if (namespace === 'home_senior') {
        wrap.classList.remove('bnr_pickup_wrap_home');
        wrap.classList.remove('bnr_pickup_wrap_home_junior');
        wrap.classList.add('bnr_pickup_wrap_home_senior');
      }

      if (namespace === 'home' || namespace === 'home_junior' || namespace === 'home_senior') {
        target.forEach((e) => {

          if (namespace === 'home_junior' && !e.classList.contains('bnr_pickup_junior')) {
            return;
          }

          if (namespace === 'home_senior' && !e.classList.contains('bnr_pickup_senior')) {
            return;
          }

          e.classList.add('is-active');
          gsap.fromTo(e, {
            y: 40,
            autoAlpha: 0,
            display: 'block',
          }, {
            y: 0,
            autoAlpha: 1,
            delay: delay,
            ease: ease,
            duration: duration,
          });

          const btn = e.querySelector('.bnr_pickup_close');
          const obj = {
            elem: e,
            handleEvent: function() {
              gsap.to(this.elem, {
                y: 40,
                autoAlpha: 0,
                ease: "slide",
              });
            },
          };
          btn.addEventListener('click', obj, false);
          listeners.push([btn, 'click', obj, false]);
        });
      }
    }
  }

  eventObserver.observeEvents(listeners);
}
